// extracted by mini-css-extract-plugin
export default {"header":"campaign_header__QGUR+"};